export default __webpack_public_path__ + "static/sponsorship@2x-079e430f2b0ed5e95d93c638125216ca.png";